// src/utils/role.js

// Safely parse the token in localStorage which may be either:
// - a raw JSON string (already decoded object), or
// - a JWT string (header.payload.signature)
// Then normalize to one of: 'superadmin' | 'admin' | 'user'

export function getAppRoleFromLocalStorage() {
  const raw = localStorage.getItem('token');
  if (!raw) return 'user';

  let roleValue = null;

  // Try JSON first
  try {
    const obj = JSON.parse(raw);
    if (obj && typeof obj === 'object' && obj.role) {
      roleValue = String(obj.role).toLowerCase();
    }
  } catch (_) {
    // Not JSON, try JWT
    const parts = raw.split('.');
    if (parts.length === 3) {
      try {
        const payload = JSON.parse(atob(parts[1]));
        if (payload && payload.role) {
          roleValue = String(payload.role).toLowerCase();
        }
      } catch (_) {
        // ignore
      }
    }
  }

  return normalizeRole(roleValue);
}

export function normalizeRole(inputRole) {
  const value = (inputRole || '').toLowerCase();

  if (value.includes('superadmin') || value === 'super admin' || value === 'super-admin') {
    return 'superadmin';
  }
  if (value.includes('admin')) {
    return 'admin';
  }
  // Any other role (e.g., 'driver', 'staff', etc.) is treated as basic user
  return 'user';
}

// Check if a menu item is allowed for a given role.
// If the item has no allowedRoles, it inherits from parentAllowedRoles.
export function isItemAllowedForRole(item, role, parentAllowedRoles) {
  const allowed = item.allowedRoles || parentAllowedRoles;
  if (!allowed || !Array.isArray(allowed)) return true; // no restriction
  return allowed.includes(role);
}

// Recursively filter a menu tree based on role.
export function filterMenuItemsByRole(items, role, parentAllowedRoles) {
  if (!Array.isArray(items)) return [];

  return items
    .map((item) => {
      if (!isItemAllowedForRole(item, role, parentAllowedRoles)) return null;

      const nextParentAllowed = item.allowedRoles || parentAllowedRoles;

      if (item.children && Array.isArray(item.children)) {
        const filteredChildren = filterMenuItemsByRole(item.children, role, nextParentAllowed);
        return { ...item, children: filteredChildren };
      }
      return item;
    })
    .filter(Boolean);
}





